import jwt_decode from 'jwt-decode'

export const getTokenUser = (roles) => {
  let token = localStorage.getItem('token')

  if (token) {
    return roles.filter((r) => jwt_decode(token).roles.includes(r)).length > 0
  }
  return false
}

export const validToken = () => {
  let token = localStorage.getItem('token')

  if (token) {
    const date = new Date()

    return jwt_decode(token).exp < date.getTime()
  }

  return false
}

export const getTokenUserSub = () => {
  let token = localStorage.getItem('token')

  return jwt_decode(token).sub
}

export const HEADERS = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
}

export const getHeadersAuth = () => {
  return {
    ...HEADERS,
    Authorization: 'Bearer '.concat(localStorage.getItem('token')),
  }
}
